"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.planName = exports.PlanType = void 0;
exports.replacePlanCode = replacePlanCode;
var PlanType;
(function (PlanType) {
    PlanType["STANDARD"] = "standard";
    PlanType["PLUS"] = "plus";
    PlanType["TEAM"] = "team";
    PlanType["BUSINESS"] = "business";
})(PlanType || (exports.PlanType = PlanType = {}));
exports.planName = {
    [PlanType.STANDARD]: 'Free',
    [PlanType.PLUS]: 'Solo',
    [PlanType.TEAM]: 'Essentials',
    [PlanType.BUSINESS]: 'Advanced'
};
/**
 * Replace plan code to plan name
 * @example
 * replacePlanCode('This is #free# plan') // This is Free plan
 * replacePlanCode('This is #plus# plan') // This is Essentials plan
 * @param str
 * @returns
 */
function replacePlanCode(str) {
    // regular expression to replace #free# to planName[PlanType.FREE], #plus# to planName[PlanType.PLUS], etc.
    return str.replace(/#([a-zA-Z]+)#/g, (_match, p1) => {
        return exports.planName[p1];
    });
}
